<template>
    <div class="containerAll">
        <div class="data-container">
            <h2 class="title">{{ plan.name }}</h2>
            <p class="local">{{ `${plan.cidade} - ${plan.estado}` }}</p>
            <span class="planPrice" v-if="!plan.planos_vinculados || plan.planos_vinculados.length == 0">
                {{ toMoney(plan.price/100) }}<span class="mes">{{ getRecorrenciaTexto(plan.unit_interval || plan.interval) }}</span>
            </span>
        </div>
        <div class="qtd-container" v-if="!plan.planos_vinculados || plan.planos_vinculados.length == 0">
            <span class="sub" @click="shoppingCar.sub(plan)">-</span>
            <span class="qtd">{{ plan.qtd }}</span>
            <span class="sum" @click="incrementarComLimite(plan)">+</span>
        </div>
    </div>

    <div v-if="plan.planos_vinculados && plan.planos_vinculados.length > 0" class="vinculados-wrapper">
        <div v-for="(p) in planLocal.planos_vinculados" :key="p.id" class="vinculado-item">
            <span class="vinculado-name">{{ p.plano.name }}</span>
            <span class="vinculado-price">
                {{ toMoney(p.plano.price/100) }}{{ getRecorrenciaTexto(p.plano.unit_interval || p.plano.interval || plan.unit_interval || plan.interval) }}
            </span>

            <div class="qtd-container">
                <span class="sub" @click="shoppingCar.sub(p.plano, p.qtd_min)">-</span>
                <span class="qtd">{{ p.plano.qtd }}</span>
                <span class="sum" @click="incrementarComLimite(p.plano)">+</span>
            </div>
        </div>
    </div>
</template>

<script>
import { inject } from '@vue/runtime-core';
import { toMoney } from '../../services/formater';

export default {
    name: "ShoppingCarCard",
    props: {
        plan: Object
    },
    data() {
        return {
            planLocal: this.plan
        }
    },
    setup(props) {
        const shoppingCar = inject("shoppingCar");
        const alert = inject("alert");

        const getRecorrenciaTexto = (interval) => {
            const tipos = {
                Monthly: "/mês",
                Bimonthly: "/bimestre",
                Quarterly: "/trimestre",
                SemiAnnual: "/semestre",
                Annual: "/ano"
            };
            return tipos[interval] || "/mês";
        };

        const incrementarComLimite = (planoalvo) => {
            const isPartOfFamilyPlan = props.plan.planos_vinculados && 
                                        props.plan.planos_vinculados.length > 0 &&
                                        props.plan.planos_vinculados.some(p => p.plano.id === planoalvo.id);
            
            if (!isPartOfFamilyPlan && planoalvo.qtd_max_membros !== null && planoalvo.qtd_max_membros !== undefined) {
                if (planoalvo.qtd + 1 > planoalvo.qtd_max_membros) {
                    alert.open(
                        "Limite Atingido", 
                        `A assinatura do plano "${planoalvo.name || planoalvo.nome}" permite apenas ${planoalvo.qtd_max_membros} participante(s).`
                    );
                    return;
                }
            }
            
            shoppingCar.sum(planoalvo);
        };

        return { toMoney, shoppingCar, incrementarComLimite, getRecorrenciaTexto }
    }
}
</script>

<style scoped>
    .containerAll{
        display: flex;
        justify-content: space-between;
        margin-bottom: 2.25rem;
        padding-right: .5rem;
    }

    .data-container{
        text-align: left;
        max-width: 15rem;
    }

    .title{
        color: #000;
        font-size: 1.0625rem;
        font-weight: 600;
        margin-bottom: 0;
        width: 100%;
    }

    .local{
        color: #4d4d4d;
        font-size: .75rem;
        font-weight: 400;
        letter-spacing: -.24px;
        margin-top: .1875rem;
    }

    .planPrice{
        color: #c90c53;
        font-size: 1rem;
        font-weight: 600;
        margin-top: .3125rem;
        display: flex;
        align-items: center;
    }

    .mes{
        color: #747474;
        font-size: .75rem;
        font-weight: 500;
        display: block;
        margin-left: .1875rem;
    }

    .qtd-container{
        width: 10.375rem;
        height: 2.625rem;
        border-radius: .1875rem;
        border: 1px solid #b7b7b7;
        display: flex;
        align-items: center;
        justify-content: space-around;
        align-self: flex-end;
    }

    .qtd{
        color: #c90c53;
        font-size: 1rem;
        font-weight: 600;
    }

    .sub, .sum{
        color: #000;
        font-size: 1.0625rem;
        font-weight: 500;
        cursor: pointer;
        padding: .25rem 1rem;
    }
    .vinculados-wrapper {
        width: 100%;
        margin-top: 1rem;
    }

    .vinculado-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: .75rem;
    }

    .vinculado-name {
        font-size: .9rem;
        font-weight: 600;
        color: #000;
    }

    .vinculado-price {
        font-size: .9rem;
        color: #c90c53;
        font-weight: 600;
        margin: 0 1rem;
    }
</style>